import { IconBaseProps, IconType } from "@/types/icon";

export const GrayArrowNarrowRightlineIcon: IconType = ({
  size = 40,
  color = "text-gray-800",
  ...props
}: IconBaseProps) => {
  return (
    <svg
      className={`${color}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 40 40"
      {...props}
    >
      <path
        d="M0 19.9999C0 8.95418 8.95431 -0.00012207 20 -0.00012207C31.0457 -0.00012207 40 8.95418 40 19.9999C40 31.0456 31.0457 39.9999 20 39.9999C8.95431 39.9999 0 31.0456 0 19.9999Z"
        fill="#1C375A"
        fill-opacity="0.16"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.752 14.3515C22.977 14.1265 23.2822 14.0001 23.6004 14.0001C23.9186 14.0001 24.2238 14.1265 24.4488 14.3515L29.2488 19.1515C29.4738 19.3765 29.6001 19.6817 29.6001 19.9999C29.6001 20.3181 29.4738 20.6232 29.2488 20.8483L24.4488 25.6483C24.2225 25.8669 23.9193 25.9878 23.6047 25.9851C23.2901 25.9823 22.9891 25.8561 22.7666 25.6336C22.5441 25.4112 22.4179 25.1102 22.4152 24.7955C22.4124 24.4809 22.5334 24.1778 22.752 23.9515L25.5036 21.1999H11.6004C11.2821 21.1999 10.9769 21.0734 10.7519 20.8484C10.5268 20.6233 10.4004 20.3181 10.4004 19.9999C10.4004 19.6816 10.5268 19.3764 10.7519 19.1513C10.9769 18.9263 11.2821 18.7999 11.6004 18.7999H25.5036L22.752 16.0483C22.527 15.8232 22.4006 15.5181 22.4006 15.1999C22.4006 14.8817 22.527 14.5765 22.752 14.3515Z"
        fill="#1C3454"
        fill-opacity="0.26"
      />
    </svg>
  );
};
